import { PageRequest } from '@/core/request/PageRequest';
import { Moment } from 'moment';

export enum Destination {
  revenue = 'domain.enums.nature_type.revenue',
  expense = 'domain.enums.nature_type.expense',
}

export interface BankingEntryListReturn {
  id: number;
  company: {
    id: number;
    name: string;
  };
  code: number;
  description: string;
  documentNumber: string;
  creationDate: string;
  value: number;
  bankAccountId: number;
  bankAccountName: string;
  refund: true;
  destination: Destination;
}

export interface BankingEntry {
  id: number;
  description: string;
  documentNumber: string;
  launchDate: string;
  conciliationDate: string;
  value: number;
  nature: Destination;
  code: number;
  bankReleaseCode: number;
  installmentAccountCode: string;
  reversed: boolean;
  installmentPayableId: number;
  installmentReceiveId: number;
  companyId: number;
  documentTypeId: number;
  planAccountId: number;
  bankAccountId: number;
  transfer: boolean;
  transferId: number;
  rateValue: number;
  amountAdjusted?: number;
  authorizationNumber?: string;
}

export interface BankingEntryQuery extends PageRequest {
  search?: string;
  companyId?: number;
  code?: string;
  description?: string;
  documentNumber?: string;
  creationDate?: string;
  value?: number;
  bankAccountId?: number;
  nature?: Destination;
}

export interface BankingEntryCreateRequest {
  companyId: number;
  description: string;
  documentNumber: string;
  bankAccountId: number;
  documentTypeId: number;
  planAccountId: number;
  nature: Destination;
  launchDate: string;
  conciliationDate: string;
  value: number;
  transfer: boolean;
  planAccountIdTransfer: number;
  bankAccountIdTransfer: number;
  companyIdTransfer?: number;
  documentTypeIdTransfer?: number;
}

export interface BankingEntryUpdateRequest {
  id: number;
  description: string;
  documentNumber: string;
  bankAccountId: number;
  documentTypeId: number;
  planAccountId: number;
  nature: Destination;
  launchDate: string;
  conciliationDate: string;
  value: number;
}

export interface BankingEntryFormValues {
  companyId: number;
  description: string;
  documentNumber: string;
  installmentAccountCode: string;
  bankAccountId: number;
  documentTypeId: number;
  planAccountId: number;
  nature: Destination;
  launchDate: Moment;
  conciliationDate: Moment;
  value: number;
  transfer: boolean;
  planAccountIdTransfer: number;
  bankAccountIdTransfer: number;
  rateValue: number;
  amountAdjusted?: number;
  authorizationNumber?: string;
}

export interface BankingEntryReversalRequest {
  id: number;
  planAccountId: number;
  reversalDate?: string;
}

export interface BankingEntryReversalFormValues {
  planAccountId: number;
  reversalDate: Moment;
}
